import { CapacityContributionStatus } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

export const WORKER_SHIFT_STATUS_ICON: Record<CapacityContributionStatus, NoddiIconName> = {
  [CapacityContributionStatus.PENDING]: 'Loader2',
  [CapacityContributionStatus.SUBMITTED]: 'Send',
  [CapacityContributionStatus.WAIT_LIST]: 'List',
  [CapacityContributionStatus.RESERVED]: 'CalendarClock',
  [CapacityContributionStatus.DECLINED]: 'XCircle',
  [CapacityContributionStatus.WITHDRAWN]: 'Undo2',
  [CapacityContributionStatus.UNASSIGNED]: 'CircleHelp',
  [CapacityContributionStatus.ASSIGNED]: 'CircleCheck'
};
